import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

class FloorPlanErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(_error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('FloorPlanViewer error:', error, errorInfo);
        this.setState({ error });
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center h-full min-h-[400px] p-8 bg-[var(--bg-hover)] rounded-lg theme-transition">
                    <AlertCircle size={48} className="text-amber-500 mb-4" />
                    <h3 className="text-lg font-semibold text-[var(--text-main)] mb-2 theme-transition">
                        3D Viewer Error
                    </h3>
                    <p className="text-[var(--text-secondary)] text-center mb-6 max-w-md theme-transition">
                        The 3D floor plan viewer encountered an error. This may be due to WebGL not being supported
                        on your device or browser.
                    </p>
                    {process.env.NODE_ENV === 'development' && this.state.error && (
                        <details className="mb-4 text-sm bg-[var(--bg-card)] p-4 rounded border border-[var(--border)] max-w-md w-full theme-transition">
                            <summary className="cursor-pointer font-medium text-[var(--text-main)] mb-2 theme-transition">
                                Error Details (Development)
                            </summary>
                            <pre className="text-xs text-[var(--text-secondary)] overflow-auto theme-transition">
                                {this.state.error.toString()}
                            </pre>
                        </details>
                    )}
                    <button
                        onClick={this.handleReset}
                        className="flex items-center space-x-2 px-4 py-2 bg-[var(--primary)] text-white rounded-lg hover:opacity-90 transition"
                    >
                        <RefreshCw size={16} />
                        <span>Try Again</span>
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default FloorPlanErrorBoundary;
